module.exports = __webpack_public_path__ + "img/CS-UltraLine-HD-Assembly.7ea6fecb.jpg";